<template>
  <div id="BDI_Group">
      <div class="page-header header-filter" data-parallax="true" style="background-image: url('static/img/bg3.jpg'); height:50vh;">
            <div class="container">
                <div class="row">
                <div class="col-md-8 ml-auto mr-auto">
                    <div class="brand text-center">
                    <h1 class="title">輔導案例</h1>
                    <h3 class="title description">Sample Case</h3>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="container">
                <div class="section text-center">                
                  <h4 class="title text-left" style="line-height:40px;">
                      Bangkok Diecasting and Injection Co., Ltd (BDI集團)以汽機車部分零件之鋁合金壓鑄及塑膠成型產品為主，主要客戶以日本Honda、Yamaha、Kawasaki、Suzuki等汽機車企業為主，
                      年銷售營業額超過25億泰銖。旗下除了塑膠射出(BDI)及鋁合金壓鑄(BAE)兩大主要生產基地外，亦於2001年創辦了泰國-臺灣(BDI)科技學院，同步發展泰國技職教育。
                      BDI集團與中原大學智慧製造研發中心2019年簽訂國際產學聯盟合約，以強化企業競爭力、協助企業轉型、達成企業永續經營之目的。本中心派遣產業聯絡專家張仁安赴泰國駐廠輔導，
                      協助BDI集團建置標準化流程，同時也導入電腦輔助工程分析(CAE)，解決製程上各式各樣的疑難雜症，並提供成型與模具技術之顧問、先進射出成型先期技術應用、新世代成型工廠技術顧問與培訓，
                      以協助BDI集團強化核心競爭力、技術升級。
                      在合作期間，並結合泰國NASDA(相當於工研院機構)協助商機開發，取得英國Zappa16套模具開發訂單，
                      並導入電腦輔助工程分析技術，協助公司降低模具開發時程與改善生產品質穩定度。並建立射出成型標準試模流程：成功降低全廠生產週期平均15%以上，全面提升品質良率，每年約節省成本超過千萬。
                      除了協助成型與模具製造之製程改善，並協助專案開發代工英國電動機車品牌，不僅強化BDI集團台灣模具供應商的開發能力與時間。同時計畫導入智能化成型參數導引系統，讓台泰兩地成型參數有共同參考標準。
                    </h4> 
                    <table style="border:0px">
                      <tbody class="text-center">
                        <tr>
                          <td colspan="2"><img style="width:600px;" src="static/img/BDI/1.jpg" alt=""></td>
                        </tr>
                        <tr>
                          <td colspan="2"><span class="title">BDI集團與中原國際產學聯盟-智慧製造中心簽訂技術合作備忘錄，並於108年正式成為國際VIP會員</span></td>
                        </tr>
                        <tr>
                          <td colspan="2"><img style="width:600px;" src="static/img/BDI/2.jpg" alt=""></td>
                        </tr>
                        <tr>
                          <td colspan="2"><span class="title">產業聯絡專家張仁安駐廠輔導</span></td>
                        </tr>
                        <tr>
                          <td><img style="width:380px;" src="static/img/BDI/3.jpg" alt=""></td>
                          <td><img style="width:380px;" src="static/img/BDI/4.jpg" alt=""></td>
                        </tr>
                        <tr>
                          <td colspan="2"><span class="title">本中心專家顧問團走訪BDI Group，參觀產線給予製程改善建議</span></td>
                        </tr>
                      </tbody>
                  </table>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "BDI_Group",
  props: [],
  data() {
    return {
      
    };
  },
  methods: {},
  filters: {},
  computed: {},
  created() {},
  mounted() {
  },
  components: {},
  watch: {}
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/pages/case/BDI_Group.vue